import React,{ useMemo } from 'react';
import { UNSELECTED_OPTION_VALUE, FIELD_TYPE } from '@fieldEngine';
import { WORKKARD_FIELD_KEY, WORKKARD_FIELD_LABEL, OWNER_PLACEHOLDER, CARRIER_PLACEHOLDER } from '../constants';
import { buildOwnerOptions } from '../utils/buildOwnerOptions';
import MakeMeOwnerButton from '../components/MakeMeOwnerButton';
import DateTimezoneAdornment from '../components/DateTimezoneAdornment';

export function useStaticFieldEnrichments({ users, carriers, currentUserId, currentUser, isEdit }) {
  return useMemo(() => ({
    'workkard number': {
      fieldKey: WORKKARD_FIELD_KEY.NUMBER,
      fieldType: FIELD_TYPE.STRING,
      label: WORKKARD_FIELD_LABEL.NUMBER,
      isRequired: true,
      description: 'Please provide an alphanumeric unique identifier so that you may use it as a reference.',
      items: [],
      fieldSettings: { colWidth: 4 }
    },
    'workkard title': {
      fieldKey: WORKKARD_FIELD_KEY.TITLE,
      fieldType: FIELD_TYPE.STRING,
      label: WORKKARD_FIELD_LABEL.TITLE,
      isRequired: true,
      description: 'Please provide a single line of text about this Workkard so that you may use it as a reference.',
      items: [],
      fieldSettings: { colWidth: 4 },
    },
    'workkard owner': {
      fieldKey: WORKKARD_FIELD_KEY.OWNER,
      fieldType: FIELD_TYPE.SINGLE_CHOICE_LIST,
      label: WORKKARD_FIELD_LABEL.OWNER,
      isRequired: true,
      description: '',
      items: buildOwnerOptions(users, currentUserId, currentUser),
      fieldSettings: currentUserId && !isEdit
        ? {
          rightAdornment: ({ value, onChange, disabled }) => (
            <MakeMeOwnerButton
              value={value}
              onChange={onChange}
              disabled={disabled}
              currentUserId={currentUserId}
            />
          ),
        }
        : undefined,
    },
    carrier: {
      fieldKey: WORKKARD_FIELD_KEY.CARRIER,
      fieldType: FIELD_TYPE.SINGLE_CHOICE_LIST,
      label: WORKKARD_FIELD_LABEL.CARRIER,
      isRequired: true,
      description: '',
      fieldSettings: {
        searchable: true,
        placeholder: 'Search carrier...',
      },
      items: carriers?.length > 0
        ? [
          { key: UNSELECTED_OPTION_VALUE, value: CARRIER_PLACEHOLDER },
          ...carriers.map((c) => ({
            key: String(c.carrier_id),
            value: c.carrier_name,
          })),
        ]
        : [],
    },
    'workkard description': {
      fieldKey: WORKKARD_FIELD_KEY.DESCRIPTION,
      fieldType: FIELD_TYPE.RICH_TEXT,
      label: WORKKARD_FIELD_LABEL.DESCRIPTION,
      isRequired: true,
      description: 'Write a few lines to describe this Workkard. Please make sure it provides good insight about the Workkard for your vendors or for future reference.',
      items: [],
    },
  }), [users, carriers, currentUserId, currentUser, isEdit]);
}
